import { useParams } from 'react-router-dom'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { getIdWithPrefix } from 'utils/pathUtils'
import { ContactCompanyType } from 'models/contact_companies'
import { NewUnmatchedLocationPage } from './new-company-pages/NewUnmatchedLocationPage'

export function DoorProxyPage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()

  const doorProxyID = urlParams?.door_proxy_id
    ? getIdWithPrefix(
        urlParams.door_proxy_id,
        preferences?.company_type_prefix_map[ContactCompanyType.UserGenerated]
      )
    : undefined

  return <NewUnmatchedLocationPage doorProxyID={doorProxyID!} />
}
